import React from 'react';
import { Spin, Row } from 'antd';
import { LayoutWithNav } from '../components/Layout';

function SessionPage() {
  return (
    <>
      <LayoutWithNav />
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '100vw',
          opacity: 0.5,
          backgroundColor: 'white',
        }}
      />
      <Row
        align="middle"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '100vw',
        }}
      >
        <div style={{ margin: 'auto' }}>
          <Spin size="large" />
        </div>
      </Row>

    </>
  );
}

export default SessionPage;
